import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

const DEFAULT_MESSAGE   = "Oops, something bad happened!  You may need to reload your browser to continue.";

class ErrorContainer extends React.Component {

    constructor(props){
        super(props);
        this.state  = {
            hasError    : false,
            error       : null
        };
    }

    componentDidCatch(error, info){
        this.setState({
            hasError    : true,
            error       : error
        });
    }

    render(){
        const { classes, message, children }   = this.props;
        const errorMessage  = message || DEFAULT_MESSAGE;
        
        if(this.state.hasError){
            return (
                <Card className={classes.root}>
                    <CardContent>
                        <Typography variant="h5">{errorMessage}</Typography>
                    </CardContent>
                </Card>
            );
        }

        return children;
    }
}

ErrorContainer.propTypes    = {
    message     : PropTypes.string
};

const styles = () => (theme => ({
    root    : {
        borderColor     : theme.palette.error.dark,
        backgroundColor : `${theme.palette.error.light}22`,
    }
}));

export default withStyles(styles)(ErrorContainer);